export class CheckEngineValidationError extends Error {
  constructor() {
    super("Field validation failed");
  }
}

export class CheckEngineAPIValidationError extends AggregateError {}

export class CheckEngineAPIServerError extends AggregateError {}
